import { render, staticRenderFns } from "./ClaimSummary.vue?vue&type=template&id=0381b2b7&scoped=true"
import script from "./ClaimSummary.vue?vue&type=script&lang=js"
export * from "./ClaimSummary.vue?vue&type=script&lang=js"
import style0 from "./ClaimSummary.vue?vue&type=style&index=0&id=0381b2b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0381b2b7",
  null
  
)

export default component.exports